import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Switch,
} from 'antd';
import dayjs from 'dayjs';
import { isEmpty, sortBy } from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DirectDiscountApi from '../../functions/api/booking/DirectDiscountApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import { dayOptions } from './constant';
var weekday = require('dayjs/plugin/weekday');
dayjs.extend(weekday);

const PromotionDateType = {
  BY_CREATED_DATE: 'BY_CREATED_DATE',
  BY_START_DATE: 'BY_START_DATE',
};

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

class FormAddRecurringDiscount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      partners: [],
      based_on: PromotionDateType.BY_CREATED_DATE,
      isEdit: !!props.match.params.discountId,
      discount: [],
      dayDiscount: [],
    };
  }
  formRef = React.createRef();

  componentDidMount = async () => {
    let partners = await PartnerApi.getAll();
    partners = sortBy(partners, ['part_name']);
    this.setState({ partners });

    const { discountId } = this.props.match.params;
    if (discountId) {
      const discount = await DirectDiscountApi.getById(discountId);
      this.setState({
        discount: discount[0],
        isEdit: true,
        dayDiscount: JSON.parse(discount[0].day_discount),
      });
    }
  };

  handleCreate = async (values) => {
    const { discount, dayDiscount } = this.state;
    let payload = {
      ...values,
      day_discount: dayDiscount,
      direct_discount_type_id: 1,
    };

    if (!payload.is_active) {
      payload.is_active = 0;
    }

    const { isEdit } = this.state;
    if (isEdit) {
      await DirectDiscountApi.update(discount.id, payload);
    } else await DirectDiscountApi.create(payload);
    message.success({
      content: 'Đã lưu',
      duration: 2,
    });
    this.props.history.push('/direct-discount');
  };

  onSelectedChange = (checked) => {
    this.formRef.current.setFieldsValue({
      is_active: checked ? 1 : 0,
    });
  };

  onChange = (values) => {
    this.setState({
      dayDiscount: values,
    });
  };

  render() {
    const { partners, isEdit, based_on, discount, dayDiscount } = this.state;

    if (isEmpty(discount) && isEdit) {
      return <Spin />;
    }

    return (
      <>
        <h1>{isEdit ? 'Sửa giảm giá định kì' : 'Thêm giảm giá định kì'}</h1>
        <Form
          {...formItemLayout}
          onFinish={this.handleCreate}
          initialValues={discount}
          ref={this.formRef}
        >
          <Card>
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['part_id']}
                  label="Áp dụng cho đối tác"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={sortBy(partners, ['part_name']).map((p) => ({
                      value: p.part_id,
                      label: p.part_name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  label="Chọn ngày được giảm giá"
                  rules={[{ required: true }]}
                >
                  <Select
                    mode="multiple"
                    showArrow
                    defaultValue={dayDiscount}
                    onChange={this.onChange}
                    style={{ width: '100%' }}
                    options={dayOptions.map((d, index) => ({
                      value: index,
                      label: d,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['discount_value']}
                  label="Giá trị giảm"
                  rules={[{ required: true }]}
                  extra="*Nhỏ hơn 100 là giảm theo %; Lớn hơn 100 là giảm theo vnđ"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['based_on']}
                  label="Điều kiện ngày"
                  rules={[{ required: true }]}
                >
                  <Select
                    className="select-partner input-normal full-width"
                    value={based_on}
                  >
                    <Select.Option value={PromotionDateType.BY_CREATED_DATE}>
                      Tính theo ngày tạo booking
                    </Select.Option>
                    <Select.Option value={PromotionDateType.BY_START_DATE}>
                      Tính theo ngày nhận xe
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="is_active" label="Kích hoạt khuyến mại">
                  <Switch
                    onChange={this.onSelectedChange}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    defaultChecked={discount.is_active}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Space className="mt-3">
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Link
              to="/direct-discount"
              component={(props) => (
                <Button type="default" {...props}>
                  Quay lại
                </Button>
              )}
            />
          </Space>
        </Form>
      </>
    );
  }
}

export default FormAddRecurringDiscount;
